import { mapActions, mapGetters, mapMutations } from "vuex";
import { directive as onClickaway } from "vue-clickaway";
import mainSelect from "@/components/main-select/index.vue";
import headerSearch from "@/components/header-search/index.vue";
import headerCatalog from "@/components/header-catalog/index.vue";
import headerMobile from "@/components/header-mobile/index.vue";
import { globalLoader } from "../../helpers/variables";
import _ from "lodash";

export default {
    name: "main-header",
    data() {
        return {
            isMobile: false,
            openHeaderMenu: false,
            showPhonesList: false,
            scrolled: false,
            fixed: false,
            showLangList: false,
            selectBranch: "",
            openSelect: false,
            changeEvent: false,
        };
    },
    directives: {
        onClickaway: onClickaway,
    },
    components: {
        "header-search": headerSearch,
        "header-catalog": headerCatalog,
        "header-mobile": headerMobile,
        mainSelect,
    },
    computed: {
        ...mapGetters({
            // showBasket: 'basket/showBasket',
            countBasketItems: `basket/countBasketItems`,
            countFavouritesItems: `favorites/favouritesListLength`,
            popupRegister: "auth/popupRegister",
            showPersonalData: "auth/showPersonalData",
            showCatalogMenu: "system/showCatalogMenu",
            isAuthenticated: `auth/isAuthenticated`,
            recommendedList: `recommendedProduct/recommendedList`,
            contact: "contacts/contacts",
            basket: "basket/basket",
            order: "basket/order",
            branches: "branches/branchesList",
            currentBranch: "branches/currentBranch",
            robots: "system/robots",
        }),
        ...mapGetters(["languages", "currentLanguage"]),

        totalAmount() {
            return this.basket.reduce((accumulator, currentValue) => {
                return (
                    accumulator +
                    (currentValue.discount_price ? currentValue.discount_price : currentValue.price) *
                        currentValue.select_count
                );
            }, 0);
        },

        branchesList() {
            if (localStorage.getItem("branchId")) {
                return this.branches.filter(
                    (item) => {
                        return item.id !== JSON.parse(localStorage.getItem("branchId")).id;
                    }
                )
            }
            return this.branches;
            // return this.selectBranch;
            // return this.getGeoSlug(this.selectBranch);
            // return this.branches;
        }
    },
    watch: {
        $route() {
            this.changeShowCatalogMenu(false);
            const cityToSlugMap = {
                Запоріжжя: "zaporizhzhya",
                Запорожье: "zaporizhzhya",
                Київ: "kyiv",
                Киев: "kyiv",
                Кременчук: "kremenchuk",
                Кременчуг: "kremenchuk",
            };

            if (this.selectBranch) {
                let geo = cityToSlugMap[this.selectBranch];
                if (geo && this.$route.params.geo !== geo && !this.changeEvent) {
                    this.navigateToNewUrl(geo);
                }
            }
        },
    },

    created() {
        if (this.$route.params.geo === "kyiv") {
            let newPath = {
                name: this.$route.name,
                query: this.$route.query,
                params: { ...this.$route.params, geo: "kremenchuk" },
            };

            this.$router.push(newPath);
        }

        this.fetchBranches().then(() => {
            Array.from(this.branches).forEach(branch => {
                if (branch.id === JSON.parse(localStorage.getItem("branchId"))?.id) {
                    this.selectBranch = branch.city_name;
                }
            });
            if (this.selectBranch && localStorage.getItem('Global-version') !== "1") {
                let geo = this.getGeoSlug(this.selectBranch);

                console.log(geo);

                if (geo) {
                    let newPath = {
                        name: this.$route.name,
                        query: this.$route.query,
                        params: { ...this.$route.params, geo },
                    };

                    try {
                        const currentRoute = {
                            name: this.$route.name,
                            query: this.$route.query,
                            params: this.$route.params,
                        };
                        if (
                            newPath.name !== currentRoute.name ||
                            JSON.stringify(newPath.query) !== JSON.stringify(currentRoute.query) ||
                            JSON.stringify(newPath.params) !== JSON.stringify(currentRoute.params)
                        ) {
                            this.$router.push(newPath).catch(err => {
                                if (!err.to || this.$route.path !== err.to.path) {
                                    console.warn(err);
                                }
                            });
                        }
                    } catch (e) {
                        console.log("Error comparing routes:", e);
                    }
                }
            }
        });
    },
    mounted() {
        this.onResize();
        this.setMeta();
        window.addEventListener("resize", this.onResize, { passive: true });

        window.document.onscroll = () => {
            this.scrolled = window.pageYOffset > 600;
        };
    },
    methods: {
        ...mapActions({
            fetchRecommendedList: `recommendedProduct/GET_RECOMMENDED_LIST`,
            fetchBranches: "branches/GET_BRANCHES",
        }),
        ...mapMutations({
            // changeShowBasket: `basket/CHANGE_SHOW_BASKET`,
            changeShowOrder: `basket/CHANGE_SHOW_ORDER`,
            changePopupRegister: `auth/CHANGE_POPUP_REGISTER`,
            changePersonalData: `auth/CHANGE_POPUP_PERSONAL_DATA`,
            changeShowCatalogMenu: `system/CHANGE_SHOW_CATALOG_MENU`,
            changePopupStatus: "branches/OPEN_POPUP_BRANCHES",
            setCurrentBranch: "branches/SET_CURRENT_BRANCH",
            resetBasket: "basket/RESET_BASKET",
            isShowFavoritePage: "system/SET_FAVORITE_PAGE",
        }),

        getGeoSlug(cityName) {
            const cityToSlugMap = {
                Запоріжжя: "zaporizhzhya",
                Запорожье: "zaporizhzhya",
                Київ: "kyiv",
                Киев: "kyiv",
                Кременчук: "kremenchuk",
                Кременчуг: "kremenchuk",
            };

            return cityToSlugMap[cityName];
        },

        generateSlugTo(cityName) {
            const cityToSlugMap = {
                Запоріжжя: "zaporizhzhya",
                Запорожье: "zaporizhzhya",
                Київ: "kyiv",
                Киев: "kyiv",
                Кременчук: "kremenchuk",
                Кременчуг: "kremenchuk",
            };

            let obj = { ...this.$route.params };
            obj.geo = cityToSlugMap[cityName];
            return obj;
        },

        setMeta() {
            this.$emit("updateHead");
        },
        getOtherLanguageLink(newLocale) {
            let baseUrl = window.location.pathname;
            baseUrl = baseUrl.replaceAll("/ru", "");
            baseUrl = baseUrl.replaceAll("/uk", "");
            if (newLocale === "ru") {
                baseUrl = "/ru" + baseUrl;
            }
            return baseUrl;
        },
        redirectToBasket() {
            this.$router.push({ name: "basket" });
        },
        setBranchId(item) {
            this.selectBranch = item.city_name;
            this.changeEvent = true;

            if (item.id !== this.currentBranch.id) {
                localStorage.getItem("products")
                    ? localStorage.setItem(`basket_${this.currentBranch.id}`, localStorage.getItem("products"))
                    : "";
                localStorage.getItem(`basket_${item.id}`)
                    ? localStorage.setItem("products", localStorage.getItem(`basket_${item.id}`))
                    : this.resetBasket();
            }
            this.setCurrentBranch(item);
            localStorage.setItem("branchId", JSON.stringify(item));
            localStorage.setItem("Global-version", 0);

            setTimeout(() => {
                window.location.href = this.generateBranchLink(item.city_name).href;
            }, 150)
        },
        openSelectBranch() {
            console.log(this.$refs.inputSelect);
            this.openSelect = !this.openSelect;
            this.$nextTick(() => {
                this.$refs.inputSelect.focus();
            })
        },
        openPopup() {
            this.changePopupStatus(false);
        },
        changeProfile() {
            if (this.isAuthenticated) {
                this.$router.push({ name: "profile-info" }).catch(() => {
                    console.log();
                });
            } else {
                this.changePopupRegister({ show: true, isRedirect: true });
            }
        },
        changeHeaderCatalog() {
            if (this.showCatalogMenu) {
                this.changeShowCatalogMenu(false);
            }
        },
        onResize() {
            this.isMobile = window.innerWidth < 1200;
        },
        // changeBasket() {
        //     if (!this.recommendedList) {
        //         this.fetchRecommendedList();
        //     }
        //     this.changeShowBasket(true);
        //     window.scrollTo({top: 0, behavior: 'smooth'});
        // },
        changeOrder() {
            this.changeShowOrder(true);
            window.scrollTo({ top: 0, behavior: "smooth" });
        },
        hidePhonesList() {
            this.showPhonesList = false;
        },
        changeWord(count) {
            let titles = [this.$t("productWord1"), this.$t("productWord2"), this.$t("productWord3")];
            let cases = [2, 0, 1, 1, 1, 2];
            return titles[count % 100 > 4 && count % 100 < 20 ? 2 : cases[count % 10 < 5 ? count % 10 : 5]];
        },
        showFavourites() {
            if (this.isAuthenticated) {
                if (this.$route.name === "profile-favourite") {
                    this.isShowFavoritePage(true);
                } else {
                    this.$router.push({ name: "profile-favourite" }).catch(() => {});
                }
            } else {
                this.changePopupRegister({ show: true, isRedirect: true });
            }
        },
        // changeHeader() {
        //     if (this.$route.name === 'home') {
        //         window.scrollTo({top: 0, behavior: 'smooth'});
        //     } else {
        //         this.$router.push({name: 'home'}).catch(() => {
        //             console.log();
        //         });
        //     }
        // },
        focusoutBranchSelector() {
          setTimeout(() => {
              this.openSelect = false
          }, 250)
        },
        generateBranchLink(name) {
            return this.$router.resolve(
                this.$localize({
                    name: this.$route.name,
                    params: this.generateSlugTo(name),
                    query: { ...this.$route.query },
                })
            );
        },

        navigateToNewUrl: _.debounce(function(geo) {
            this.$router.push({
                name: this.$route.name,
                query: this.$route.query,
                params: { ...this.$route.params, geo },
            });
        }, 300),

        closeLangList() {
            this.showLangList = false;
        },
        changeLanguage(item) {
            let link = this.getOtherLanguageLink(item.key);
            window.location.pathname = link;
        },
    },

    destroyed() {
        window.removeEventListener("scroll", this.handleScroll);
    },
};
